import React from 'react';
import { Col, Label, NewDateInput, Row, themes } from '@digitools/honest-react';
import useExperience from 'src/hooks/useExperience';
import useTranslate from 'src/hooks/useTranslate';
import useCliDataContext from '../../../hooks/useCliDataContext';
import { CustomEmployeeText } from 'src/utils/CustomExperienceText';
import { Experience } from 'src/types/Experience';
import { addYears, isBefore, parse } from 'date-fns';
import AboutYourAbsenceText from '../../../constants/AboutYourAbsenceText';
import { useFormState } from 'informed';
import { validateDateIsWithinAYear } from 'src/packages/cli/utils/validationUtils';
const ReleaseDate = () => {
    const { absenceData } = useCliDataContext();
    const { t } = useTranslate();
    const { experience, language } = useExperience();
    const { formLabels } = AboutYourAbsenceText;
    const { values } = useFormState();
    const labelText = CustomEmployeeText(experience === Experience.EMPLOYEE ? t(formLabels.releaseDateEE) : t(formLabels.releaseDateER));
    // FIXME: can't allow same day temporarily (needing fix for backend)
    const validateReleaseDate = (input) => {
        if (input && values?.absenceData?.admissionDate) {
            if (isBefore(parse(input, 'P', new Date()), parse(values.absenceData.admissionDate, 'P', new Date()))) {
                return t(formLabels.releaseDateError);
            }
        }
        return validateDateIsWithinAYear(input, t, formLabels.releaseDateShortLabel, false);
    };
    return (<>
      <Row className='mb-3'>
        <Col size={12}>
          <Label className='mb-2'>{labelText}</Label>
        </Col>
        <Col size={12} sm={6} xl={4}>
          <NewDateInput data-testid='releaseDate' theme={themes.rebrand} field={'releaseDate'} lang={language} label={t(formLabels.releaseDateShortLabel)} placeholder={'mm/dd/yyyy'} ariaLabelText={labelText} minDate={values?.absenceData?.admissionDate ? new Date(values?.absenceData?.admissionDate) : undefined} maxDate={addYears(new Date(), 1)} validate={validateReleaseDate} initialValue={absenceData && absenceData.releaseDate}/>
        </Col>
      </Row>
    </>);
};
export default ReleaseDate;
